<section class="booking-details">
  <div class="top-section">
    <h3>
      Booking Details
    </h3>
  </div>
  <div class="middle-section">
    <div class="container">
      <div class="rate-request-form">
        <form [formGroup]="bookingForm">
          <div class="form-group  from-to-section">
            <div class="row">
              <div class="col-md-6">
                <h4 class="main-title">
                  From
                </h4>
                <div class="row m-t-30 m-r-0">
                  <div class="col-md-6 form-group">
                    <label class="custom-labal ">
                      Country
                    </label>
                    <div class="pRel">
                      <p-dropdown [options]="fromCountries" [readonly]="readonly" optionLabel="countryName"
                        formControlName="fromCountry" placeholder="Select Country" [virtualScroll]="true"
                        [filter]="false" [itemSize]="31"  class="p-dropdown"></p-dropdown>
                    </div>
                    
                    <div *ngIf="hasError('fromCountry', 'required') && submitted" class="invalid-Validation">
                      From Country is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group">
                    <label class="custom-labal ">
                      Port
                    </label>
                    <div class="pRel">
                      <p-dropdown [options]="fromPort" [readonly]="readonly" optionLabel="portName"
                        formControlName="fromPort" placeholder="Select Port" [virtualScroll]="true" [filter]="false"
                        [itemSize]="31" class="p-dropdown"></p-dropdown>
                    </div>
                    <div *ngIf="hasError('fromPort', 'required') && submitted" class="invalid-Validation">
                      From Port is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="main-title">
                  To
                </h4>
                <div class="row m-t-30 m-r-0">
                  <div class="col-md-6 form-group">
                    <label class="custom-labal ">
                      Country
                    </label>
                    <div class="pRel">
                      <p-dropdown [options]="toCountries" [readonly]="readonly" optionLabel="countryName"
                        formControlName="toCountry" placeholder="Select Country" [virtualScroll]="true" [filter]="false"
                        [itemSize]="31" class="p-dropdown"></p-dropdown>
                    </div>
                    <div *ngIf="hasError('toCountry', 'required') && submitted" class="invalid-Validation">
                      ToCountry is required
                    </div>
                  </div>
                  <div class="col-md-6 form-group">
                    <label class="custom-labal ">
                      Port
                    </label>
                    <div class="pRel">
                      <p-dropdown [options]="toPort" [readonly]="readonly" optionLabel="portName"
                        formControlName="toPort" placeholder="Select Port" [virtualScroll]="true" 
                        [itemSize]="31" class="p-dropdown"
                        [filter]="false">
                      </p-dropdown>
                    </div>
                    <div *ngIf="hasError('toPort', 'required') && submitted" class="invalid-Validation">
                      ToPort is required
                    </div>
                  </div>
                </div>
              </div>
              <span class="arrow arrow-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18.793" height="29.276" viewBox="0 0 19.793 20.276">
                  <defs>
                    <style>
                      .a {
                        fill: #15536b;
                      }
                    </style>
                  </defs>
                  <g transform="translate(-23.998 -87.999)">
                    <path class="a"
                      d="M161.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,161.447,108.275Z"
                      transform="translate(-127.793 0)" />
                    <path class="a"
                      d="M25.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,25.447,108.275Z"
                      transform="translate(0 0)" />
                  </g>
                </svg>
              </span>
            </div>
            <hr class="hr-1 m-t-30" />
          </div>
          <div class="form-group m-t-30">
            <h4 class="main-title">
              Consignment Details
            </h4>
            <div class="row m-t-30">
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  Cargo Type
                </label>
                <div class="pRel">
                  <p-dropdown [options]="cargoTypes" optionLabel="name" formControlName="cargoClass"
                    placeholder="Select Cargo Type" class="p-dropdown" (onChange)="getCargoSegment($event)"
                    [filter]="false" [itemSize]="31" [virtualScroll]="true"></p-dropdown>
                </div>
                <div *ngIf="hasError('cargoClass', 'required') && submitted" class="invalid-Validation">
                  Cargo Type is required
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  Cargo Segment
                </label>
                <div class="pRel">
                  <p-dropdown [options]="cargoSegments" class="p-dropdown" optionLabel="name"
                    formControlName="cargoSegment" placeholder="Select Cargo Segment" [virtualScroll]="true"
                    [itemSize]="31" [filter]="false">
                  </p-dropdown>
                </div>
                <div *ngIf="hasError('cargoSegment', 'required') && submitted" class="invalid-Validation">
                  Cargo Segment is required
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  Condition
                </label>
                <div class="pRel">
                  <p-dropdown [options]="cargoConditions" class="p-dropdown" optionLabel="viewValue"
                    formControlName="cargoCondition" placeholder="Select Condition" [filter]="false"
                    [itemSize]="31" [virtualScroll]="true">
                  </p-dropdown>
                </div>
                <div *ngIf="hasError('cargoCondition', 'required') && submitted" class="invalid-Validation">
                  Condition is required
                </div>
              </div>
            </div>
            <div class="row m-t-30">
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  When can cargo be in loadport?
                </label>
                <div class="">
                  <p-calendar [readonlyInput]="true" formControlName="cargoLanPortDate" [minDate]="minDate"
                    showIcon="true" showButtonBar="true" placeholder="Date" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left"
                    dateFormat="dd-MM-yy">
                  </p-calendar>

                </div>
                <div *ngIf="hasError('cargoLanPortDate', 'required') && submitted" class="invalid-Validation">
                  When can cargo be in loadport? is required
                </div>
              </div>

              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  Number of Units
                </label>

                <input type="number"  class="form-control" formControlName="noOfUnits" placeholder="0" step="1"
                  (change)="FixedNumber()" />
                <div *ngIf="hasError('noOfUnits', 'required') && submitted" class="invalid-Validation">
                  No Of Units is required
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  Shipping Lines
                </label>
                <div class="pRel">
                  <p-dropdown [options]="shippinglineslist" [readonly]="readonly" formControlName="shippinglineId"
                    class="p-dropdown" optionLabel="shippingLineName" placeholder="Select ShippingLines"
                    [filter]="false" [itemSize]="31" [virtualScroll]="true">
                  </p-dropdown>
                </div>
                <div *ngIf="hasError('shippinglineId', 'required') && submitted" class="invalid-Validation">
                  Shipping Line is required
                </div>
              </div>
            </div>
            <div class="row m-t-30">
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Length(m)
                </label>
                <!-- <input type="number" class="form-control" formControlName="length" placeholder="Length"
                                    step="1"  *ngIf="readonly" readonly/> -->
                <input type="number" class="form-control" name="my_field" pattern="^-?\d*(\.\d{0,2})?$"
                  formControlName="length" placeholder="Length" step="1" (change)="calculateSQM()" />
                <div *ngIf="hasError('length', 'required') && submitted" class="invalid-Validation">
                  Length is required
                </div>
              </div>
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Width(m)
                </label>
                <!-- <input type="number" class="form-control"  formControlName="width" placeholder="Width"
                                    step="1"  *ngIf="readonly" readonly/> -->
                <input type="number" class="form-control" name="my_field" pattern="^-?\d*(\.\d{0,2})?$"
                  formControlName="width" placeholder="Width" step="1" (change)="calculateSQM()" />
                <div *ngIf="hasError('width', 'required') && submitted" class="invalid-Validation">
                  Width is required
                </div>
              </div>
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Height(m)
                </label>
                <!-- <input type="number" class="form-control"  formControlName="height" placeholder="Height"
                                    step="1"  *ngIf="readonly" readonly/> -->
                <input type="number" class="form-control" name="my_field" pattern="^-?\d*(\.\d{0,2})?$"
                  formControlName="height" placeholder="Height" step="1" (change)="calulateCBM()" />
                <div *ngIf="hasError('height', 'required') && submitted" class="invalid-Validation">
                  Height is required
                </div>
              </div>
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Weight(mt)
                </label>
                <!-- <input type="number" class="form-control"  formControlName="weight" placeholder="Weight"
                                    step="1" *ngIf="readonly" readonly/> -->
                <input type="number" class="form-control" name="my_field" pattern="^-?\d*(\.\d{0,2})?$"
                  formControlName="weight" placeholder="Weight" step="1" />
                <div *ngIf="hasError('weight', 'required') && submitted" class="invalid-Validation">
                  Weight is required
                </div>
              </div>
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Sqm(m2)
                </label>
                <input type="number" class="form-control" formControlName="sqm" placeholder="Sqm" step="1" readonly />
                <div *ngIf="hasError('sqm', 'required') && submitted" class="invalid-Validation">
                  Sqm is required
                </div>
              </div>
              <div class="col-md-2 form-group">
                <label class="custom-labal">
                  Cbm(m3)
                </label>
                <input type="number" class="form-control" formControlName="cbm" placeholder="Cbm" step="1" readonly />
                <div *ngIf="hasError('cbm', 'required') && submitted" class="invalid-Validation">
                  Cbm is required
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 form-group">
                <label class="custom-labal">
                  <span> Package And Description</span>(Car & H&H: make,model manufacture
                  year,self-propelled.Break Bulk: Packging Description)
                </label>
                <textarea rows="1" maxlength="250" formControlName="description" class="form-control"
                  (keyup)="onKeyPress()" placeholder="Description">
							  </textarea>
                <div class="font-12 mt-2">
                  <span *ngIf="descriptionLength == false">Total characters: {{totalChar}}</span>
                  <span *ngIf="descriptionLength == true">Remaining characters: {{totalChar}}</span>
                </div>
                <div *ngIf="hasError('description', 'required') && submitted" class="invalid-Validation">
                  Package and Description is required
                </div>
              </div>
            </div>
            <hr class="hr-1 m-t-30" />
          </div>
          <div class="form-group m-t-30 table-responsive" *ngIf="makeRaterequest">
            <h4 class="main-title">
              Charges
            </h4>
            <div class="mt-3">
              <table class="table">
                <tr>
                  <th>
                    Description
                  </th>
                  <th>
                    Rate
                  </th>
                  <th>
                    Terms
                  </th>
                  <th>
                    Total
                  </th>
                </tr>
                <tr>
                  <td>
                    Freight Rate
                  </td>
                  <td>
                    {{bookingForm.controls.freightrate.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.freightratebasis.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.ratetotal.value}}
                  </td>
                </tr>
                <tr>
                  <td>
                    BAF
                  </td>
                  <td>
                    {{bookingForm.controls.baf.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.bafbasis.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.baftotal.value}}
                  </td>
                </tr>
                <tr>
                  <td>
                    CAF
                  </td>
                  <td>
                    {{bookingForm.controls.caf.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.cafbasis.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.caftotal.value}}
                  </td>
                </tr>
                <tr>
                  <td>
                    THF
                  </td>
                  <td>
                    {{bookingForm.controls.thc.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.thcbasis.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.thctotal.value}}
                  </td>
                </tr>
                <tr>
                  <td>
                    Other Charges
                  </td>
                  <td>
                    {{bookingForm.controls.othercharges.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.otherchargesbasis.value}}
                  </td>
                  <td>
                    {{bookingForm.controls.otherchargestotal.value}}
                  </td>
                </tr>
                <tr>
                  <td colspan="3"></td>
                  <td colspan="4">
                    <strong>
                      $ {{bookingForm.controls.totalsumofallcost.value}}
                    </strong>
                  </td>
                </tr>
              </table>
            </div>
            <hr class="hr-1 m-t-30" />
          </div>
          <div class="form-group m-t-30 termsandcondition">
            <h4 class="main-title" *ngIf="makeRaterequest">
              Terms And Condition
            </h4>
            <ul class="list-unstyled" *ngIf="makeRaterequest">
              <li>
                <strong>
                  1. IMPORTANT: </strong> International shipping rates ro-ro, in roro carrier's
                booking confirmations offered at a time of booking, are based on
                information provided by shipper. Cargo (vehicles) will be verified at
                a time of submitting to the ro-ro carrier's pier. Ro-ro Carrier's
                final invoice will be based on actual type of cargo (vehicle)
                submitted to the ro-ro shipment and its w/m (weight/measurement)
                verification.
              </li>
              <li>
                <strong>
                  2. RO-RO PORT & THC (Terminal Handling Charges):</strong> Shipper
                is responsible to pay all applicable Port & THC at a time of
                submitting vehicle(s) to the ro-ro carrier's pier.
              </li>
              <li>
                <strong>
                  3. DESTINATION
                  CHARGES: </strong> All destination charges (i.e. taxes and duties, customs, port
                and carrier's destination agent charges, storage, demurrage if any
                etc) collect for account of consignee (importer of records).
              </li>
            </ul>
            <div class="col-12 text-right">
              <div class="custom-control custom-radio custom-control-inline" *ngIf="makeRaterequest">
                <!-- <input type="radio" id="customRadioInline1" name="customRadioInline1"
                                    class="custom-control-input" /> -->
                <p-checkbox formControlName="termsCondition" binary="true"
                  label="I Agree to the delivery terms and Condition."></p-checkbox>
                <div *ngIf="hasError('termsCondition', 'required') && submitted" class="invalid-Validation">
                  Terms and Condition is required
                </div>
              </div>
              <!-- <button class="btn  btn-orange2">Cancel</button> -->
              <button *ngIf="!openPoup && !rateselected" class="btn btn-signIn" (click)="submitBookingForm()">
                Next</button>
              <button *ngIf="openPoup" id="openpoup" class="btn btn-signIn" data-toggle="modal"
                data-target="#viewoffredrate"> Next</button>
              <button class="btn  btn-signIn" *ngIf="rateselected" (click)="SaveBookingDetails()">Book</button>
              <!-- <div id="paypal-button"></div>                             -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
<!-- <button class="btn btn-signIn" id="clic" data-toggle="modal" data-target="#viewoffredrate" > </button> -->
<div class="modal fade" id="viewoffredrate" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content text-left">
      <div class="modal-header">
        <h5 class="modal-title ">Select Offered Rates</h5>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close-btn" id="closemodel">
          <span class="pi pi-fw pi-times"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <p-table [value]="offeredratelist" *ngIf="totalCount > 0">
            <ng-template pTemplate="header">
              <tr>
                <th width="40"></th>
                <th>From Port</th>
                <th>To Port</th>
                <th>Offered By</th>
                <th>Shipping Cost($)</th>
                <th>Rate Valid Till</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-offereate>
              <tr>
                <td>
                  <p-radioButton name="group1" value="{{offereate.offeredRateId}}" [(ngModel)]="selected"
                    inputId="opt1">
                  </p-radioButton>
                </td>
                <td>{{offereate.fromPortName}}</td>
                <td>{{offereate.toPortName}}</td>
                <td>{{offereate.offeredBy}}</td>
                <td>{{offereate.totalOfferedRate }}</td>
                <td>{{offereate.freightRateValidTill  | date:'dd-MM-yyyy'}}</td>
                <td>
                  <a data-toggle="modal" data-target=".view-modal" pTooltip="View Details" tooltipPosition="top"
                    class="text-success"
                    (click)="GetOfferdRate(offereate.rateRequestId,offereate.fromPortName,offereate.toPortName,offereate.offeredRateId)">
                    <i class="fa fa-eye"></i></a></td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="totalCount == 0">
            <span> No Offerd Found. We have Sent an Rate Request.</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" *ngIf="totalCount > 0" class="btn btn-signIn " (click)="OnRateSelection()">Get Booking
          Deatils</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade view-modal modelzindex2 request-modal" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <form [formGroup]="RateForm">
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-header">
          <h5 class="modal-title ">Freight Request Summery.</h5>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close-btn" #closeRateModal>
            <span class="pi pi-fw pi-times"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                From Port
              </label>
              <span>
                {{frmport}}
              </span>
            </div>
            <span class="arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.793" height="29.276" viewBox="0 0 19.793 20.276">
                <defs>
                  <style>
                    .a {
                      fill: #15536b;
                    }
                  </style>
                </defs>
                <g transform="translate(-23.998 -87.999)">
                  <path class="a"
                    d="M161.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,161.447,108.275Z"
                    transform="translate(-127.793 0)" />
                  <path class="a"
                    d="M25.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,25.447,108.275Z"
                    transform="translate(0 0)" />
                </g>
              </svg>
            </span>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                To Port
              </label>
              <span>
                {{toport}}
              </span>
            </div>
            <div class="col-md-4 form-group">
              <span class="badge badge-success">
                <label class="custom-labal ">
                  Offered Rate :
                </label>
                <span>
                  ${{offeredamount}}
                </span>
              </span>
            </div>

            <!-- <div class="col-md-4 form-group">
                <button class="btn btn-signIn" data-toggle="modal" data-target=".view-poprereq"> Re-Rate
                  Request</button>
              </div> -->
          </div>
          <div class="row">
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total number of units
              </label>
              <input type="text" class="form-control" formControlName="noOfUnits" readonly />
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total LaneMeters
              </label>
              <input type="text" formControlName="totallanemeters" class="form-control" readonly />
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total Cubic Meters
              </label>
              <input type="text" class="form-control" formControlName="totalCubicmeters" readonly />
            </div>
          </div>
          <hr class="hr-1 m-t-30">
          <h5 class="modal-title m-t-30 ">Freight request summary</h5>
          <div class="row ui-table">
            <div class="col-md-12 table-responsive   request-summary m-t-30">
              <table class="table table-striped ">
                <tr>
                  <th>Description</th>
                  <th>Rate Basis</th>
                  <th>Rate</th>
                  <th>Sum</th>
                </tr>
                <tr>
                  <td>
                    Freght Rate
                  </td>
                  <td>
                    {{selectedRatename}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field"
                      pattern="^-?\d*(\.\d{0,2})?$" formControlName="freightrate" readonly />
                    <div *ngIf="hasError('freightrate', 'required') && submitted" class="invalid-Validation">
                      freight rate is required
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalrate" formControlName="ratetotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    BAF
                  </td>
                  <td>
                    {{selectedBAFname}}
                  </td>

                  <td>
                    <input type="text" class="form-control " placeholder="0.00" name="my_field"
                      pattern="^-?\d*(\.\d{0,2})?$" formControlName="baf" readonly />
                    <div *ngIf="hasError('baf', 'required') && submitted" class="invalid-Validation">
                      BAF Rate is required
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalbaf" formControlName="baftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    CAF
                  </td>
                  <td>
                    {{selectedCafname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field"
                      pattern="^-?\d*(\.\d{0,2})?$" formControlName="caf" readonly />
                    <div *ngIf="hasError('caf', 'required') && submitted" class="invalid-Validation">
                      CAF Rate is required
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalcaf" formControlName="caftotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    THC
                  </td>
                  <td>
                    {{selectedThcname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field"
                      pattern="^-?\d*(\.\d{0,2})?$" formControlName="thc" readonly />
                    <div *ngIf="hasError('thc', 'required') && submitted" class="invalid-Validation">
                      THC Rate is required
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalthc" formControlName="thctotal" readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    Other Charges
                  </td>
                  <td>
                    {{selectedOtherchargesname}}
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="0.00" name="my_field"
                      pattern="^-?\d*(\.\d{0,2})?$" formControlName="othercharges" readonly />
                    <div *ngIf="hasError('othercharges', 'required') && submitted" class="invalid-Validation">
                      Other Charges Rate is required
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control totalothercharges" formControlName="otherchargestotal"
                      readonly />
                  </td>
                </tr>
                <tr>
                  <td>
                    Total Freight Cost
                  </td>
                  <td>

                  </td>
                  <td>

                  </td>
                  <td>
                    <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost"
                      readonly />
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr class="hr-1 ">
          <h5 class="modal-title  ">Freigh cost summary</h5>
          <div class="row ">
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Cost per unit
              </label>
              <input type="text" class="form-control costperunt" formControlName="costperunit" readonly />
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Cost per CubicMeter
              </label>
              <input type="text" class="form-control costpercubicmeter" formControlName="costpercubicmeter" readonly />
            </div>
            <div class="col-md-4 form-group">
              <label class="custom-labal ">
                Total Cost
              </label>
              <input type="text" class="form-control totalsumofallcost" formControlName="totalsumofallcost" readonly />
            </div>

          </div>
          <div class="row">
            <div class="col-md-4 offset-md-8">
              <label class="custom-labal ">
                Freight Rate Validity
              </label>
              <!-- <input type="text" class="form-control" formControlName="freightratevalidity" readonly /> -->
              <p-calendar [readonlyInput]="true" formControlName="freightratevalidity" showIcon="true"
                showButtonBar="true" placeholder="Date" [minDate]="minDate" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left"
                dateFormat="dd-MM-yy" [disabled]="true">
              </p-calendar>
              <div *ngIf="hasError('freightratevalidity', 'required') && submitted" class="invalid-Validation">
                Freight Rate Validity Date is required.
              </div>
            </div>
          </div>
          <hr class="hr-1 ">
          <div class="row ">
            <div class="col-md-12">
              <p>
                This rate quotation confirmation contains:
                the tariff ocean rates
                global surcharges such as BAF, SRC and Canal Surcharge where applicable
                validity date for these rates
                standard Terms and Conditions that are applicable
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal fade add-paymetpopup request-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true" style="overflow: auto !important;">
  <!-- <form [formGroup]="RateForm" (ngSubmit)="SubmitRate()"> -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-header">
          <h5 class="modal-title ">Select Payment Method</h5>
          <button type="button" data-dismiss="modal" id="closepoup" aria-label="Close" class="close-btn" #closeRateModalsub>
            <span class="pi pi-fw pi-times"></span>
          </button>
          <button id="openModalButton" [hidden]="true" data-toggle="modal" data-target=".add-paymetpopup">Open Modal</button>
        </div>
        <div class="modal-body">
         <div class="row">
              <label>
                Total Amount : $ {{totalpaymentcost}}
              </label>
         </div>
          <div id="paypal-button-container"></div>
          </div>
        <div class="modal-footer">
        </div>
      </div>
    </div>
</div>